import createVueApp from '@/common/createApp'

Styxie.Initializers.UsersRegistrations = {
  new: async(props) => {
    const { default: RegistrationsNew } = await import('@/vue_widgets/users/registrations/new/index.vue')
    createVueApp(RegistrationsNew, { props, layout: null })
  }
}
